import { safeProduce as produce } from "~helpers/immer";

import * as at from "./actionTypes";

export const initState = {
  statisticGenerator: null,
  statisticsFigure: null,
  filterState: {
    categories: {}, // filterName : [...filterCategories]
    filters: {},
    filterValues: {}, // filterName : {type, begin, end} or {type, values}, depending on the type
    agentFilter: [],
    dateFilter: {
      begin: null,
      end: null,
    },
  },
};

const statisticGenerator = (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case at.SET_STATISTICS_GENERATOR:
        draft.statisticGenerator = action.payload;
        break;
      case at.SET_STATISTICS_FIGURE:
        draft.statisticsFigure = action.payload;
        break;
    }
  });

export default statisticGenerator;
